<app-hero [title]="'Bewerbung'"></app-hero>
<section id="alt-services" class="alt-services section">
    <div class="container">
      <div class="row justify-content-around gy-4">
        <div class="col-lg-5 d-flex flex-column justify-content-center" data-aos="fade-up" data-aos-delay="200">
            <h3>Bewerben Sie sich für {{jobDetails.title}}</h3>
            <p data-aos="fade-up" data-aos-delay="300">
              {{jobDetails.text}}
            </p>
            <a *ngIf="jobDetails" [routerLink]="['/job-details', jobDetails.id]">
              Weiterlesen <i class="bi bi-arrow-right"></i>
            </a>

            <form (ngSubmit)="submitApplication()" #appForm="ngForm" class="mt-2">
              <!-- Cover Letter -->
              <div class="mb-3">
                <label for="coverLetter" class="form-label">Anschreiben (optional)</label>
                <textarea id="coverLetter" class="form-control" rows="4"
                          [(ngModel)]="coverLetter" name="coverLetter"></textarea>
              </div>

              <!-- CV Upload -->
              <div class="mb-3">
                <label for="cv" class="form-label">Lebenslauf hochladen</label>
                <input type="file" id="cv" class="form-control" accept="application/pdf" (change)="onFileSelected($event)" required>
                <small class="text-muted">Zulässige PDF-Dateien. Maximale Größe 2 MB.</small>
              </div>

              <button type="submit" class="btn btn-primary" [disabled]="!selectedFile">Bewerbung absenden</button>
            </form>
        </div>
        <div class="features-image col-lg-6" data-aos="fade-up" data-aos-delay="100">
          <img [src]="jobDetails.image" alt="Unsere Dienstleistungen">
        </div>
      </div>
    </div>
</section>